import { generateRandomString } from '@mntn-dev/utilities'
import { z } from 'zod'

export const PaymentIdSchema = z.string().brand('payment-id')

export type PaymentId = z.infer<typeof PaymentIdSchema>

export const PaymentId = (
  value: string = generateRandomString()
): PaymentId => {
  return PaymentIdSchema.parse(value)
}
